import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@ui/base/accordion'

import { sectionTitle } from './typography'

export type LandingQuestion = { question: string; answer: string }

/**
 * Частые вопросы. Ответы остаются в разметке и закрытыми: их находит поиск по странице и
 * поисковый робот.
 */
export const LandingFaq = ({ id, items, title }: { id: string; items: LandingQuestion[]; title: string }) => (
  <section aria-labelledby={`${id}-title`} className="scroll-mt-20 pt-4 pb-16 lg:pb-20" id={id}>
    <h2 id={`${id}-title`} className={`${sectionTitle} mb-8`}>
      {title}
    </h2>

    <Accordion className="max-w-[900px] gap-2.5">
      {items.map(({ answer, question }) => (
        <AccordionItem key={question}>
          <AccordionTrigger className="py-5 text-[17.5px]">{question}</AccordionTrigger>
          <AccordionContent className="max-w-[70ch] pb-5">{answer}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
)

/** Разметка вопросов и ответов для поисковика: он показывает её списком прямо в выдаче. */
export const faqPageSchema = (items: LandingQuestion[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map(({ answer, question }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: { '@type': 'Answer', text: answer },
  })),
})
